import { render } from "./LocaleSwitcher.vue?vue&type=template&id=bb77dd22&scoped=true"
import script from "./LocaleSwitcher.vue?vue&type=script&lang=js"
export * from "./LocaleSwitcher.vue?vue&type=script&lang=js"

import "./LocaleSwitcher.vue?vue&type=style&index=0&id=bb77dd22&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src703991735/src/Jessy-Rent-O-/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb77dd22"]])

export default __exports__